import { Button, PageContainer, PageHeader } from "@touche-lts/panel-ui/dist"
import { IconUserManagement } from 'assets/icons'
import { observer } from "mobx-react-lite"
import { useRootStore } from "mobx-stores/store-provider"
import { useEffect } from "react"
import { useParams } from "react-router"
import { CategoriesDepartmentsPage } from "./categories"
import { GalleryDepartmentsPage } from "./image-department-gallery/image-department-gallery-page"
import cl from 'classnames'
import styles from '../departments-page.module.scss'
import { useGetIsResponsiveScreen } from "hooks/custom-hooks"

const AddDepartmentPageComponent = (props) => {
  const {
    className,
    style,
    history: { push }
  } = props,
    {
      departmentsStore: {
        addUpdateDepartment,
        getDepartmentById,
        departmentStore
      }
    } = useRootStore(),

    { departmentId } = useParams<{ departmentId: string }>();

  useEffect(() => {
    if (departmentId) {
      getDepartmentById(departmentId);
    }
    localStorage.removeItem('subCategoryEdit');
  }, [departmentId, getDepartmentById])

  const {isResponsive:isLaptop} = useGetIsResponsiveScreen('(max-width: 1024px)')

  return (
    <PageContainer className={cl(styles.scrollable,className)}>
      <PageHeader
        navSegments={[
          {
            icon: IconUserManagement,
            label: 'Departments',
            iconProps: { viewBox: '0 0 22 22' },
            onClick: () => push('/departments')
          },
          {
            label: !!departmentId ? `Edit Department` : 'Add new Department'
          }
        ]}
         middleContainerChildren={
          isLaptop && 
          <>
            <div className={styles.middleContainerStyle} style={{flexDirection:'column'}}>
              <Button preset='secondary' onClick={() => push('/departments')}>
                Discard Changes
              </Button>
              <Button preset='primary' children={!!departmentId ? 'Update Department' : 'Add New Department'} onClick={() => addUpdateDepartment(departmentId)} />
            </div>
          </>
        }
        buttons={!isLaptop ? [
          {
            preset: 'secondary',
            children: 'Discard Changes',
            onClick: () => push('/departments')
          },
          {
            preset: 'primary',
            children: !!departmentId ? 'Update Department' : 'Add New Department',
            onClick: () => addUpdateDepartment(departmentId)
          }
        ] : []}
      />
      <GalleryDepartmentsPage />
      {departmentId && !!departmentStore && (
        <div className='pt-4'>
          <CategoriesDepartmentsPage />
        </div>
      )}
    </PageContainer>
  )
},

  AddDepartmentsPage = observer(AddDepartmentPageComponent)
export { AddDepartmentsPage }
